export enum RFETMLicenseActionTypes {
    API_RESPONSE_SUCCESS = '@@rfetmLicenses/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@rfetmLicenses/API_RESPONSE_ERROR',

    GET_RFETM_LICENSES = '@@rfetmLicenses/GET_RFETM_LICENSES',
}
